import styled from 'styled-components';
import { Badge as BaseBadge, views } from '@salutejs/plasma-core';
import { collectPackageInfo } from '../../collectPackageInfo';
collectPackageInfo('Badge/Badge');
export var badgeViews = {
  primary: views.primary,
  secondary: views.overlay,
  warning: views.warning
};

/**
 * Небольшая бирка для ячеек и карточек.
 * Компонент может отображаться в нескольких размерах и цветах, может содержать текст и/или иконку.
 */
export var Badge = /*#__PURE__*/styled(BaseBadge).withConfig({
  componentId: "plasma-ui__sc-vvsdz6-0"
})(["", ";"], function (_ref) {
  var _ref$view = _ref.view,
      view = _ref$view === void 0 ? 'primary' : _ref$view;
  return badgeViews[view];
});